import { Injectable } from '@angular/core';
import { ConfigurationDataService } from '../configuration-data.service';
import { SharedDataService } from '../shared-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Customer } from './customer';

@Injectable()
export class CustomerService {

  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(public http: HttpClient, private config: ConfigurationDataService, private shared: SharedDataService) {
  }

  /**
   * List all customers which belong to loggedin user.
   */
  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.customerURL + "list", JSON.stringify(this.shared.getTokenAuthData()), { headers: this.headers });
  }

  public save(customer: Customer) {
    console.log('Push customer to insert method of service.');
    customer.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(customer));
    return this.http.post(this.config.customerURL + "new", JSON.stringify(customer), { headers: this.headers });
  }

  public update(customer: Customer) {
    console.log('Push customer to insert method of service.');
    customer.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(customer));
    return this.http.put(this.config.customerURL + "id/" + customer.id, JSON.stringify(customer), { headers: this.headers });
  }

  public qryCustomer(id: number) {
    return this.http.post(this.config.customerURL + "id/" + id,
      JSON.stringify(this.shared.getTokenAuthData()), { headers: this.headers });
  }

  public delete(id: number) {
    console.log('Delete customer ' + id);
    return this.http.post(this.config.customerURL + "del/" + id,
      JSON.stringify(this.shared.getTokenAuthData()), { headers: this.headers });
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/customer/customer.service.ts